import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import TradingLayout from "../TradingLayout";

import CreateTradingEnquiryPage from "../pages/CreateTradingEnquiryPage";
import TradingEnquiryListPage from "../pages/TradingEnquiryListPage";
import TradingEnquiryDetailPage from "../pages/TradingEnquiryDetailPage";

import TradingCostingListPage from "../pages/TradingCostingListPage";
import TradingCostingDetailPage from "../pages/TradingCostingDetailPage";

import TradingQuotationListPage from "../pages/TradingQuotationListPage";
import TradingQuotationFormPage from "../pages/TradingQuotationFormPage";
import TradingQuotationDetailPage from "../pages/TradingQuotationDetailPage";

import TradingSalesOrderListPage from "../pages/TradingSalesOrderListPage";
import TradingSalesOrderSelectQuotationPage from "../pages/TradingSalesOrderSelectQuotationPage";
import TradingSalesOrderDetailPage from "../pages/TradingSalesOrderDetailPage";

// Dispatch Orders
import TradingDispatchOrderListPage from "../dispatch_order/pages/TradingDispatchOrderListPage";
// File: frontend/src/modules/trading/routes/TradingRoutes.js
import TradingDispatchOrderCreatePage from "../dispatch_order/pages/TradingDispatchOrderCreatePage";
import TradingDispatchOrderDetailPage from "../dispatch_order/pages/TradingDispatchOrderDetailPage";
import TradingDispatchOrderEditPage from "../dispatch_order/pages/TradingDispatchOrderEditPage";

// Actual Dispatch
import ActualDispatchListPage from "../actual_dispatch/pages/ActualDispatchListPage";
import ActualDispatchCreatePage from "../actual_dispatch/pages/ActualDispatchCreatePage";
import ActualDispatchDetailPage from "../actual_dispatch/pages/ActualDispatchDetailPage";

import ActualDispatchEditPage from "../actual_dispatch/pages/ActualDispatchEditPage";

// Sales Invoice
import TradingSalesInvoiceListPage from   "../sales_invoice/pages/TradingSalesInvoiceListPage";
import TradingSalesInvoiceCreatePage from   "../sales_invoice/pages/TradingSalesInvoiceCreatePage";
import TradingSalesInvoiceViewPage from "../sales_invoice/pages/TradingSalesInvoiceViewPage";

import TradingSalesInvoiceEditPage from "../sales_invoice/pages/TradingSalesInvoiceEditPage";

export default function TradingRoutes() {
  return (
    <TradingLayout>
      <Routes>
        <Route index element={<Navigate to="enquiries" replace />} />

        {/* Trading Enquiries */}
        <Route
          path="enquiries"
          element={<TradingEnquiryListPage />}
        />

        <Route
          path="enquiries/create"
          element={<CreateTradingEnquiryPage />}
        />

        <Route
          path="enquiries/:id"
          element={<TradingEnquiryDetailPage />}
        />

        {/* Trading Costings */}
        <Route
          path="costings"
          element={<TradingCostingListPage />}
        />

        <Route
          path="costings/:id"
          element={<TradingCostingDetailPage />}
        />

        {/* Trading Quotations */}
        <Route
          path="quotations"
          element={<TradingQuotationListPage />}
        />

        <Route
          path="quotations/create"
          element={<TradingQuotationFormPage />}
        />

        <Route
          path="quotations/:id"
          element={<TradingQuotationDetailPage />}
        />

        {/* Trading Sales Orders */}
        <Route
          path="sales-orders"
          element={<TradingSalesOrderListPage />}
        />

        <Route
          path="sales-orders/select-quotation"
          element={<TradingSalesOrderSelectQuotationPage />}
        />
        <Route
          path="sales-orders/:id"
          element={<TradingSalesOrderDetailPage />}
        />
        {/* Trading Dispatch Orders */}
        <Route
          path="dispatch-orders"
          element={<TradingDispatchOrderListPage />}
        />
        <Route
          path="dispatch-orders/create"
          element={<TradingDispatchOrderCreatePage />}
        />
        <Route
          path="dispatch-orders/:id"
          element={<TradingDispatchOrderDetailPage />}
        />
        <Route
          path="dispatch-orders/:id/edit"
          element={<TradingDispatchOrderEditPage />}
        />
        {/* Trading Actual Dispatch */}
          <Route
            path="actual-dispatches"
            element={<ActualDispatchListPage />}
          />

          <Route
            path="actual-dispatches/create"
            element={<ActualDispatchCreatePage />}
          />
          <Route
            path="actual-dispatches/:id"
            element={<ActualDispatchDetailPage />}
          />
          <Route
            path="/trading/actual-dispatches/:id/edit"
            element={<ActualDispatchEditPage />}
          />

          {/* Trading Sales Invoices */}
          <Route
            path="sales-invoices"
            element={<TradingSalesInvoiceListPage />}
          />
          <Route
            path="sales-invoices/create"
            element={<TradingSalesInvoiceCreatePage />}
          />
          <Route
            path="sales-invoices/:id"
            element={<TradingSalesInvoiceViewPage />}
          />
        <Route
          path="sales-invoices/:id/edit"
          element={<TradingSalesInvoiceEditPage />}
        />

      </Routes>
    </TradingLayout>
  );
}